import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/provider/brands'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class BrandsApi {

    static async initBrands({ data = undefined, ...params }) {
        return await fetchService({ url: '/initbrands', method: 'POST', data, ...params })
    }

    static async changeBrand({ data = { name: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changebrand', method: 'PATCH', data, notify: { msg: 'Изменения сохранены' }, ...params })
    }

    static async getBrands({ data = { tab: undefined, _market: undefined, search: undefined, limit: undefined }, ...params }) {
        return await fetchService({ url: '/getbrands', method: 'POST', data, notify: { success: false }, ...params })
    }

}